import React, { Component } from 'react'
import { MenuItem } from 'app/common/layout/menu'
import { Text } from 'app/common/typography'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import styled from 'styled-components'
import { KingdomCard } from './Card'

type Props = {
    fetchCardData: () => void,
    kingdomAuthCode: string,
    dataLoaded: boolean,
    blazonProfileImageUrl?: string,
    intl: IntlShape
}

class Card extends Component<Props> {
    componentDidMount() {
        const { fetchCardData } = this.props
        fetchCardData()
    }

    render() {
        const { intl, dataLoaded } = this.props
        const breadcrumb = [
            {
                link: intl.formatMessage({ id: 'routes.kingdom.dashboard' }),
                title: intl.formatMessage({
                    id: 'kingdom.dashboard.title.breadcrumb.end'
                })
            },
            {
                title: intl.formatMessage({
                    id: 'kingdom.card.title.breadcrumb.end'
                })
            }
        ]

        return (
            <MenuItem
                breadcrumb={breadcrumb}
                url={intl.formatMessage({ id: 'routes.kingdom.dashboard' })}
                title={intl.formatMessage({ id: 'kingdom.card.title' })}
                description={intl.formatMessage({
                    id: 'kingdom.card.description'
                })}>
                {dataLoaded && (
                    <Container>
                        <KingdomCard />
                        <TextContainer>
                            <FormattedMessage id="kingdom.card.content">
                                {(text: string) => (
                                    <StyledText>{text}</StyledText>
                                )}
                            </FormattedMessage>
                        </TextContainer>
                    </Container>
                )}
            </MenuItem>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
`

const TextContainer = styled.div`
    max-width: 400px;
    text-align: center;
`

const StyledText = styled(Text)`
    display: block;
    margin-bottom: 10px;
`

const CardComponent = injectIntl(Card)

export { CardComponent }
